/* Copyright (c) 2017 Backpack Health LLC */

/* global document */
/* eslint-disable react/no-did-mount-set-state */

import React from 'react';
import PropTypes from 'prop-types';

function withDynamicFontSize(Component, defaultFontSize, maxHeight) {
  class DynamicFontSize extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        defaultFontSize,
        fontSize: defaultFontSize,
        verticalDiff: 0,
      };
    }

    componentDidMount() {
      const parentNode = document.getElementById('app');
      const clone = this.contentRef.children[0].cloneNode(true);
      parentNode.appendChild(clone);

      let fontSize = defaultFontSize;
      let height = clone.getBoundingClientRect().height;
      while (height > maxHeight) {
        if (fontSize < 8) { break; }
        fontSize--;
        clone.style.fontSize = `${fontSize}px`;
        height = clone.getBoundingClientRect().height;
      }

      height = clone.getBoundingClientRect().height;

      parentNode.removeChild(clone);

      this.setState({
        fontSize,
        verticalDiff: maxHeight - height,
      });
    }

    render() {
      const { fontSize, verticalDiff } = this.state;

      return (
        <div style={{ fontSize: `${fontSize}px`, height: maxHeight }} ref={(r) => { this.contentRef = r; }}>
          <Component {...this.props} verticalOffset={verticalDiff} />
        </div>
      );
    }
  }
  DynamicFontSize.propTypes = {
    children: PropTypes.any,
    defaultFontSize: PropTypes.number,
    maxHeight: PropTypes.number,
  };

  return DynamicFontSize;
}

export default withDynamicFontSize;
